export const noti = {
    text1: "Powiadomienia",
    text2: "Lista powiadomień.",
    text3: "Brak powiadomień",
};